import { MasterState } from '@/store/master/types';

const state: MasterState = {
  positions: [],
  universities: [],
  campuses: [],
  semesters: [],
  nationalities: [],
  timetables: [],
  transportationExpenses: [],
  holidays: [],
  levels: [],
  subjects: [],
  vacationReasons: [],
  specialConsiderations: [],
  boothBuilding: [],
  boothRoom: [],
  boothNumber: [],
};

export default state;
